import {createApp} from 'vue';
import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import ApiService from "@/api/apiService";
import AppConfig from "@/config/appConfig";
import AuthService from "@/api/authService";
import {setupI18n} from "@/i18n";
import BackOfficeService from "@/api/BackOfficeService";
import Toaster from "@meforma/vue-toaster";
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

declare global {
  interface Window {
    QRCodeInterval: undefined | number;
  }
}

let i18n: any;

function isProductFilePage(): boolean {
  const regex = new RegExp(`/product-file-page/`);
  return regex.test(window.location.pathname);
}

async function init() {
  if (!await AppConfig.init()) return;

  const isI18nNeeded = isProductFilePage();

  if (isI18nNeeded) {
    BackOfficeService.init();
    i18n = await setupI18n({
      globalInjection: true,
      legacy: false,
      locale: 'en_GB', // Default locale
      messages: {},
      fallbackLocale: 'en_GB',
      warnHtmlMessage: false,
    });
  }

  AuthService.init();
  ApiService.init();

  const piniaStore = createPinia();
  piniaStore.use(piniaPluginPersistedstate);

  const app = createApp(App);
  app.use(store);
  app.use(piniaStore);
  app.use(router);
  if (isI18nNeeded) {
    app.use(i18n);
  }
  app.use(Toaster, { position: 'top-right' }).provide('toast', app.config.globalProperties.$toast);
  app.mount('#app');
}

init();

export {i18n};
